import { authFetch } from './auth';

export async function fetchTodayRecord(barnId) {
  const res = await authFetch(
    `/api/dead-chicken-records?barnId=${encodeURIComponent(barnId)}`
  );
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || '載入失敗');
  }

  return data;
}

export async function createDeadChickenRecord(barnId, employeeCount) {
  const res = await authFetch('/api/dead-chicken-records', {
    method: 'POST',
    body: JSON.stringify({ barnId, employeeCount })
  });
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || '儲存失敗');
  }

  return data;
}

export async function updateDeadChickenRecord(barnId, employeeCount) {
  const res = await authFetch(
    `/api/dead-chicken-records?barnId=${encodeURIComponent(barnId)}`,
    {
      method: 'PUT',
      body: JSON.stringify({ employeeCount })
    }
  );
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || '儲存失敗');
  }

  return data;
}

export async function fetchDeadChickenReport({ barnId, zone, dateFrom, dateTo } = {}) {
  const params = new URLSearchParams();

  if (barnId) params.set('barnId', barnId);
  if (zone) params.set('zone', zone);
  if (dateFrom) params.set('dateFrom', dateFrom);
  if (dateTo) params.set('dateTo', dateTo);

  const query = params.toString();
  const res = await authFetch(`/api/dead-chicken-report${query ? `?${query}` : ''}`);
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || '載入失敗');
  }

  return data;
}

export async function fetchActiveBarns() {
  const res = await authFetch('/api/dead-chicken-report?type=barns');
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || '載入失敗');
  }

  return data.barns;
}
